import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "faq-container" }
const _hoisted_2 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_3 = {
  key: 1,
  class: "error-container"
}
const _hoisted_4 = {
  key: 2,
  class: "content-container"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 3,
  class: "empty-container"
}

import { ref, onMounted, computed, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'FAQPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const { locale } = useI18n();

// 内容地址
const contentUrl = ref('');
// 加载状态
const loading = ref(false);
// 错误信息
const error = ref('');

// 返回首页函数
const goBack = () => {
  router.push('/');
};

// 检查是否是图片
const isImage = computed(() => {
  if (!contentUrl.value) return false;
  const url = contentUrl.value.toLowerCase();
  return url.endsWith('.jpg') || url.endsWith('.jpeg') || url.endsWith('.png') || url.endsWith('.gif') || url.endsWith('.webp');
});

// 检查是否是PDF
const isPdf = computed(() => {
  if (!contentUrl.value) return false;
  return contentUrl.value.toLowerCase().endsWith('.pdf');
});

// 处理URL字符串，去除多余的空格和反引号
const processUrl = (url: string): string => {
  return url.replace(/^[\s`]+|[\s`]+$/g, '');
};

// 获取内容URL的函数
const fetchContentUrl = async () => {
  const menuId = route.query.menuId;
  
  if (!menuId) {
    error.value = '没有获取到菜单ID';
    return;
  }
  
  loading.value = true;
  error.value = '';
  
  try {
    // 调用接口获取内容URL，使用菜单id作为参数
    const response = await fetch(`/jeecg-boot/energycube/menu/queryMenuDetail?id=${menuId}`);
    const data = await response.json();
    
    if (data.code === 200 && data.result && data.result.length > 0) {
      // 根据当前语言选择对应的URL
      const currentLang = locale.value;
      const item = data.result[0];
      
      // 选择对应的URL
      let url = '';
      if (currentLang === 'zh-Hant') {
        url = processUrl(item.imgUrl);
      } else {
        url = processUrl(item.imgUrlen);
      }
      
      contentUrl.value = url;
    } else {
      error.value = '获取内容链接失败';
    }
  } catch (err) {
    console.error('获取内容链接失败:', err);
    error.value = '网络错误，请稍后重试';
  } finally {
    loading.value = false;
  }
};

// 监听语言变化，重新获取内容
watch(locale, () => {
  if (route.query.menuId) {
    fetchContentUrl();
  }
});

// 组件挂载时获取内容URL
onMounted(() => {
  fetchContentUrl();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "back-button-container" }, [
      _createElementVNode("button", {
        onClick: goBack,
        class: "back-button"
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("span", { class: "back-arrow" }, "←", -1),
        _createTextVNode(" 返回首页 ", -1)
      ]))])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("div", { class: "loading-spinner" }, null, -1),
          _createElementVNode("p", null, "加载中...", -1)
        ]))]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", null, "加载失败：" + _toDisplayString(error.value), 1),
            _createElementVNode("button", {
              onClick: fetchContentUrl,
              class: "retry-button"
            }, "重试")
          ]))
        : (contentUrl.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (isImage.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: contentUrl.value,
                    alt: "常见问题",
                    class: "image-viewer"
                  }, null, 8, _hoisted_5))
                : (isPdf.value)
                  ? (_openBlock(), _createElementBlock("iframe", {
                      key: 1,
                      src: contentUrl.value,
                      title: "常见问题",
                      class: "pdf-viewer",
                      frameborder: "0"
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("p", null, "没有找到相关内容", -1)
            ]))]))
  ]))
}
}

})